// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import DOMPurify from 'dompurify';
// import { 
//   getAllTerms, 
//   getTermsById,
//   createTerms, 
//   updateTerms, 
//   toggleTermsStatus,
//   getTermsHistory 
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/TermsManage.css';

// import {
//   FiEye,
//   FiEdit2,
//   FiClock,
//   FiToggleLeft,
//   FiToggleRight,
//   FiSearch,
//   FiFilter,
//   FiRefreshCw,
//   FiDownload,
//   FiPlus,
//   FiTrash2,
//   FiChevronLeft,
//   FiChevronRight,
//   FiX,
//   FiCheck,
//   FiAlertCircle,
//   FiInfo,
//   FiFileText,
//   FiCalendar,
//   FiUser,
//   FiTag,
//   FiLayers,
// } from 'react-icons/fi';

// // ============================================================
// // ✅ SANITIZATION CONFIGURATION
// // ============================================================

// const SANITIZE_CONFIG = {
//   ALLOWED_TAGS: [
//     'b', 'i', 'u', 'em', 'strong', 'p', 'br',
//     'ul', 'ol', 'li', 'dl', 'dt', 'dd',
//     'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
//     'table', 'thead', 'tbody', 'tr', 'td', 'th',
//     'blockquote', 'pre', 'code', 'hr', 'div', 'span',
//     'a', 'abbr', 'address', 'cite', 'q'
//   ],
//   ALLOWED_ATTR: [
//     'href', 'target', 'rel',
//     'class', 'id', 'style',
//     'title', 'align', 'colspan', 'rowspan'
//   ],
//   ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
// };

// // ============================================================
// // ✅ SANITIZATION HELPERS
// // ============================================================

// const sanitizeHTML = (content) => {
//   if (!content || typeof content !== 'string') return '';
//   return DOMPurify.sanitize(content, SANITIZE_CONFIG);
// };

// const sanitizeSections = (sections) => {
//   if (!sections || !Array.isArray(sections)) return sections;
//   return sections.map(section => ({
//     ...section,
//     content: DOMPurify.sanitize(section.content, SANITIZE_CONFIG)
//   }));
// };

// // ============================================================
// // ✅ SKELETON COMPONENTS
// // ============================================================

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="stat-icon skeleton-icon"></div>
//     <div className="stat-content">
//       <div className="skeleton-value"></div>
//       <div className="skeleton-title"></div>
//     </div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge-small"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="terms-table-container skeleton">
//     <div className="table-responsive">
//       <table className="modern-table">
//         <thead>
//           <tr>
//             <th className="text-center">#</th>
//             <th>Type</th>
//             <th>Title & Details</th>
//             <th className="text-center">Version</th>
//             <th className="text-center">Status</th>
//             <th>Last Updated</th>
//             <th className="text-center">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//             <SkeletonTableRow key={i} />
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content view-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="modal-title-section">
//           <div className="skeleton-title"></div>
//           <div className="skeleton-subtitle"></div>
//         </div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="terms-metadata">
//           <div className="metadata-grid">
//             {[1, 2, 3, 4].map((i) => (
//               <div key={i} className="metadata-item">
//                 <div className="skeleton-label"></div>
//                 <div className="skeleton-value"></div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="terms-content-preview">
//           <div className="content-header">
//             <div className="skeleton-subtitle"></div>
//           </div>
//           <div className="sections-container">
//             {[1, 2, 3].map((i) => (
//               <div key={i} className="section-item">
//                 <div className="skeleton-section-header"></div>
//                 <div className="skeleton-section-content"></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonFormModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content create-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="create-form">
//           <div className="form-grid">
//             {[1, 2, 3].map((i) => (
//               <div key={i} className="form-group">
//                 <div className="skeleton-label"></div>
//                 <div className="skeleton-input"></div>
//               </div>
//             ))}
//           </div>
//           <div className="sections-editor">
//             <div className="editor-header">
//               <div className="skeleton-subtitle"></div>
//               <div className="skeleton-button-small"></div>
//             </div>
//             <div className="sections-list">
//               {[1, 2].map((i) => (
//                 <div key={i} className="section-editor-item">
//                   <div className="section-editor-header">
//                     <div className="skeleton-label-small"></div>
//                     <div className="skeleton-button-small"></div>
//                   </div>
//                   <div className="form-group">
//                     <div className="skeleton-label"></div>
//                     <div className="skeleton-input"></div>
//                   </div>
//                   <div className="form-group">
//                     <div className="skeleton-label"></div>
//                     <div className="skeleton-textarea"></div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// // ============================================================
// // ✅ MAIN COMPONENT
// // ============================================================

// const TermsAndConditions = () => {
//   const { token } = useSelector(state => state.user);
//   const [terms, setTerms] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterType, setFilterType] = useState('');
//   const [editingTerms, setEditingTerms] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingTerms, setViewingTerms] = useState(null);
//   const [selectedHistory, setSelectedHistory] = useState(null);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const [newTermsForm, setNewTermsForm] = useState({
//     type: '',
//     title: '',
//     sections: [{ title: '', content: '' }],
//     effectiveDate: new Date().toISOString().split('T')[0]
//   });
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalTerms, setTotalTerms] = useState(0);
//   const [pageSize] = useState(10);

//   const termTypes = [
//     { value: '', label: 'All Types', icon: '📄', color: '#6366f1' },
//     { value: 'general', label: 'General Terms', icon: '📋', color: '#10b981' },
//     { value: 'passenger', label: 'Passenger Terms', icon: '👤', color: '#3b82f6' },
//     { value: 'bus_owner', label: 'Bus Owner Terms', icon: '🚌', color: '#f59e0b' },
//     { value: 'privacy', label: 'Privacy Policy', icon: '🔒', color: '#8b5cf6' },
//     { value: 'cookie', label: 'Cookie Policy', icon: '🍪', color: '#ec4899' },
//     { value: 'refund', label: 'Refund Policy', icon: '💸', color: '#ef4444' }
//   ];

//   useEffect(() => {
//     fetchTerms();
//   }, [currentPage, searchTerm, filterType]);

//   // ============================================================
//   // ✅ API FUNCTIONS
//   // ============================================================

//   const fetchTerms = async () => {
//     try {
//       setLoading(true);
//       const response = await getAllTerms(token, currentPage, pageSize, filterType, searchTerm);

//       if (response && response.success) {
//         const transformedTerms = response.terms.map((term, index) => ({
//           id: term._id || term.id,
//           serialNo: (currentPage - 1) * pageSize + index + 1,
//           type: term.type,
//           typeLabel: getTypeLabel(term.type),
//           typeColor: getTypeColor(term.type),
//           typeIcon: getTypeIcon(term.type),
//           title: term.title,
//           version: term.version,
//           isActive: term.isActive,
//           effectiveDate: new Date(term.effectiveDate).toLocaleDateString('en-US'),
//           lastUpdated: new Date(term.updatedAt || term.lastUpdatedAt).toLocaleDateString('en-US'),
//           lastUpdatedBy: term.lastUpdatedBy?.name || 'System Admin',
//           content: term.content
//         }));

//         setTerms(transformedTerms);
//         setTotalPages(response.totalPages || 1);
//         setTotalTerms(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch terms and conditions.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getTypeLabel = (type) => {
//     const typeMap = {
//       'general': 'General Terms',
//       'passenger': 'Passenger Terms',
//       'bus_owner': 'Bus Owner Terms',
//       'privacy': 'Privacy Policy',
//       'cookie': 'Cookie Policy',
//       'refund': 'Refund Policy'
//     };
//     return typeMap[type] || type;
//   };

//   const getTypeColor = (type) => {
//     const colorMap = {
//       'general': '#10b981',
//       'passenger': '#3b82f6',
//       'bus_owner': '#f59e0b',
//       'privacy': '#8b5cf6',
//       'cookie': '#ec4899',
//       'refund': '#ef4444'
//     };
//     return colorMap[type] || '#6b7280';
//   };

//   const getTypeIcon = (type) => {
//     const iconMap = {
//       'general': '📋',
//       'passenger': '👤',
//       'bus_owner': '🚌',
//       'privacy': '🔒',
//       'cookie': '🍪',
//       'refund': '💸'
//     };
//     return iconMap[type] || '📄';
//   };

//   // ============================================================
//   // ✅ VIEW, EDIT, HISTORY HANDLERS
//   // ============================================================

//   const handleViewTerms = async (term) => {
//     try {
//       setIsFetchingDetails(true);
//       const response = await getTermsById(term.id, token);
//       if (response.success) {
//         const sections = parseContentToSections(response.terms.content);
//         setViewingTerms({
//           ...term,
//           sections: sections.length > 0 ? sections : [{ title: 'Full Terms', content: response.terms.content }]
//         });
//       }
//     } catch (err) {
//       setError('Failed to fetch term details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const parseContentToSections = (content) => {
//     const sections = [];
//     if (!content) return sections;
    
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(content, 'text/html');
//     const sectionElements = doc.querySelectorAll('.terms-section');
    
//     if (sectionElements.length > 0) {
//       sectionElements.forEach((sectionEl, index) => {
//         const titleEl = sectionEl.querySelector('.section-title');
//         const contentEl = sectionEl.querySelector('.section-content');
        
//         if (titleEl && contentEl) {
//           const titleText = titleEl.textContent.replace(/^\d+\.\s*/, '');
//           sections.push({
//             title: titleText,
//             content: contentEl.innerHTML
//           });
//         }
//       });
//     }
    
//     return sections;
//   };

//   const handleViewHistory = async (termId, termTitle) => {
//     try {
//       setIsFetchingDetails(true);
//       const response = await getTermsHistory(termId, token);
//       if (response.success) {
//         setSelectedHistory({
//           termId,
//           termTitle,
//           history: response.history || []
//         });
//         setShowHistoryModal(true);
//       }
//     } catch (err) {
//       setError('Failed to fetch history.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   // ============================================================
//   // ✅ CREATE TERMS HANDLERS
//   // ============================================================

//   const handleCreateNew = () => {
//     setShowCreateModal(true);
//     setNewTermsForm({
//       type: '',
//       title: '',
//       sections: [
//         { 
//           title: 'Acceptance of Terms', 
//           content: 'By accessing and using this website, you agree to be bound by these terms and conditions.' 
//         },
//         { 
//           title: 'User Responsibilities', 
//           content: 'Users must provide accurate information and use the service responsibly.' 
//         }
//       ],
//       effectiveDate: new Date().toISOString().split('T')[0]
//     });
//   };

//   const handleAddSection = () => {
//     setNewTermsForm({
//       ...newTermsForm,
//       sections: [...newTermsForm.sections, { title: '', content: '' }]
//     });
//   };

//   const handleRemoveSection = (index) => {
//     if (newTermsForm.sections.length > 1) {
//       const newSections = [...newTermsForm.sections];
//       newSections.splice(index, 1);
//       setNewTermsForm({
//         ...newTermsForm,
//         sections: newSections
//       });
//     }
//   };

//   const handleSectionChange = (index, field, value) => {
//     const newSections = [...newTermsForm.sections];
//     newSections[index][field] = value;
//     setNewTermsForm({
//       ...newTermsForm,
//       sections: newSections
//     });
//   };

//   // ============================================================
//   // ✅ FIXED: CREATE SUBMIT WITH SANITIZATION
//   // ============================================================

//   const handleCreateSubmit = async () => {
//     try {
//       setError(null);
      
//       if (!newTermsForm.type || !newTermsForm.title || !newTermsForm.sections.length) {
//         setError('Please fill all required fields');
//         return;
//       }

//       for (let i = 0; i < newTermsForm.sections.length; i++) {
//         if (!newTermsForm.sections[i].title.trim() || !newTermsForm.sections[i].content.trim()) {
//           setError(`Please fill both header and content for section ${i + 1}`);
//           return;
//         }
//       }

//       // ✅ Sanitize sections before sending to server
//       const sanitizedSections = sanitizeSections(newTermsForm.sections);

//       const response = await createTerms({
//         ...newTermsForm,
//         sections: sanitizedSections
//       }, token);
      
//       if (response.success) {
//         setSuccess('Terms and conditions created successfully!');
//         setShowCreateModal(false);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response.message || 'Failed to create terms');
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to create terms');
//     }
//   };

//   // ============================================================
//   // ✅ EDIT TERMS HANDLERS
//   // ============================================================

//   const handleEditTerms = async (term) => {
//     try {
//       setIsFetchingDetails(true);
//       const response = await getTermsById(term.id, token);
//       if (response.success) {
//         const sections = parseContentToSections(response.terms.content);
//         setEditingTerms(term.id);
//         setEditForm({
//           title: term.title,
//           sections: sections.length > 0 ? sections : [{ title: 'Terms and Conditions', content: response.terms.content }],
//           isActive: term.isActive,
//           effectiveDate: new Date(term.effectiveDate).toISOString().split('T')[0],
//           changeReason: ''
//         });
//         setShowEditModal(true);
//       }
//     } catch (err) {
//       setError('Failed to load term for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditSectionChange = (index, field, value) => {
//     const newSections = [...editForm.sections];
//     newSections[index][field] = value;
//     setEditForm({
//       ...editForm,
//       sections: newSections
//     });
//   };

//   const handleAddEditSection = () => {
//     setEditForm({
//       ...editForm,
//       sections: [...editForm.sections, { title: '', content: '' }]
//     });
//   };

//   const handleRemoveEditSection = (index) => {
//     if (editForm.sections.length > 1) {
//       const newSections = [...editForm.sections];
//       newSections.splice(index, 1);
//       setEditForm({
//         ...editForm,
//         sections: newSections
//       });
//     }
//   };

//   // ============================================================
//   // ✅ FIXED: SAVE EDIT WITH SANITIZATION
//   // ============================================================

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editForm.changeReason) {
//         setError('Please provide a change reason for this update');
//         return;
//       }

//       for (let i = 0; i < editForm.sections.length; i++) {
//         if (!editForm.sections[i].title.trim() || !editForm.sections[i].content.trim()) {
//           setError(`Please fill both header and content for section ${i + 1}`);
//           return;
//         }
//       }

//       // ✅ Sanitize sections before sending to server
//       const sanitizedSections = sanitizeSections(editForm.sections);

//       const response = await updateTerms(editingTerms, {
//         ...editForm,
//         sections: sanitizedSections
//       }, token);

//       if (response.success) {
//         setSuccess('Terms updated successfully!');
//         setEditingTerms(null);
//         setEditForm({});
//         setShowEditModal(false);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       } else {
//         setError(response.message || 'Failed to update terms');
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to update terms');
//     }
//   };

//   // ============================================================
//   // ✅ TOGGLE STATUS
//   // ============================================================

//   const handleToggleStatus = async (termId, currentStatus) => {
//     try {
//       setError(null);
//       const response = await toggleTermsStatus(termId, token);
      
//       if (response.success) {
//         setSuccess(`Terms ${currentStatus ? 'deactivated' : 'activated'} successfully!`);
//         fetchTerms();
//         setTimeout(() => setSuccess(null), 3000);
//       }
//     } catch (err) {
//       setError('Failed to update status');
//     }
//   };

//   // ============================================================
//   // ✅ SEARCH, FILTER, PAGINATION
//   // ============================================================

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleTypeFilter = (e) => {
//     setFilterType(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     fetchTerms();
//   };

//   const handleExportCSV = () => {
//     if (terms.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['ID', 'Type', 'Title', 'Version', 'Status', 'Effective Date', 'Last Updated', 'Updated By'];
//     const csvData = terms.map(term => [
//       term.id,
//       term.typeLabel,
//       term.title,
//       term.version,
//       term.isActive ? 'Active' : 'Inactive',
//       term.effectiveDate,
//       term.lastUpdated,
//       term.lastUpdatedBy
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `terms-and-conditions-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const getStatusBadge = (isActive) => {
//     return (
//       <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
//         <span className="status-dot"></span>
//         {isActive ? 'Active' : 'Inactive'}
//       </span>
//     );
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const closeViewModal = () => {
//     setViewingTerms(null);
//   };

//   const closeHistoryModal = () => {
//     setShowHistoryModal(false);
//     setSelectedHistory(null);
//   };

//   const closeCreateModal = () => {
//     setShowCreateModal(false);
//     setNewTermsForm({
//       type: '',
//       title: '',
//       sections: [{ title: '', content: '' }],
//       effectiveDate: new Date().toISOString().split('T')[0]
//     });
//   };

//   const closeEditModal = () => {
//     setShowEditModal(false);
//     setEditingTerms(null);
//     setEditForm({});
//   };

//   const filterTerms = terms.filter(term => 
//     term.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     term.typeLabel.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // ============================================================
//   // ✅ RENDER: LOADING STATE
//   // ============================================================

//   if (loading && terms.length === 0) {
//     return (
//       <div className="terms-management-page">
//         <div className="terms-header">
//           <div className="header-left">
//             <div className="skeleton-header-title"></div>
//             <div className="skeleton-header-subtitle"></div>
//           </div>
//           <div className="header-right">
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="terms-stats-grid">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <div className="filters-section">
//           <div className="search-box">
//             <div className="skeleton-search"></div>
//           </div>
//           <div className="filter-actions">
//             <div className="skeleton-select"></div>
//             <div className="skeleton-button-small"></div>
//             <div className="skeleton-button-small"></div>
//           </div>
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   // ============================================================
//   // ✅ RENDER: MAIN
//   // ============================================================

//   return (
//     <div className="terms-management-page">

//       <div className="terms-header">
//         <div className="header-left">
//           <h1><FiFileText /> Terms & Conditions</h1>
//           <p className="subtitle">Manage all terms, policies, and agreements</p>
//         </div>
//         <div className="header-right">
//           <button className="btn btn-primary" onClick={handleCreateNew}>
//             <FiPlus /> Create New
//           </button>
//         </div>
//       </div>

//       <div className="terms-stats-grid">
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//             <FiLayers />
//           </div>
//           <div className="stat-content">
//             <h3>{totalTerms}</h3>
//             <p>Total Terms</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)' }}>
//             <FiCheck />
//           </div>
//           <div className="stat-content">
//             <h3>{terms.filter(t => t.isActive).length}</h3>
//             <p>Active</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)' }}>
//             <FiTag />
//           </div>
//           <div className="stat-content">
//             <h3>{[...new Set(terms.map(t => t.type))].length}</h3>
//             <p>Types</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)' }}>
//             <FiClock />
//           </div>
//           <div className="stat-content">
//             <h3>v{Math.max(...terms.map(t => t.version || 1))}</h3>
//             <p>Latest Version</p>
//           </div>
//         </div>
//       </div>

//       <div className="filters-section">
//         <div className="search-box">
//           <FiSearch className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search terms by title or type..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             className="search-input"
//           />
//         </div>
//         <div className="filter-actions">
//           <div className="filter-group">
//             <FiFilter className="filter-icon" />
//             <select
//               className="filter-select"
//               value={filterType}
//               onChange={handleTypeFilter}
//             >
//               {termTypes.map(type => (
//                 <option key={type.value} value={type.value}>
//                   {type.label}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <button className="btn btn-secondary" onClick={handleRefresh}>
//             <FiRefreshCw /> Refresh
//           </button>
//           <button className="btn btn-outline" onClick={handleExportCSV}>
//             <FiDownload /> Export
//           </button>
//         </div>
//       </div>

//       <div className="terms-table-container">
//         <div className="table-responsive">
//           <table className="modern-table">
//             <thead>
//               <tr>
//                 <th className="text-center">#</th>
//                 <th>Type</th>
//                 <th>Title & Details</th>
//                 <th className="text-center">Version</th>
//                 <th className="text-center">Status</th>
//                 <th>Last Updated</th>
//                 <th className="text-center">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filterTerms.map(term => (
//                 <tr key={term.id}>
//                   <td className="text-center">{term.serialNo}</td>
//                   <td>
//                     <div className="type-badge" style={{ backgroundColor: term.typeColor + '15', color: term.typeColor, borderColor: term.typeColor + '40' }}>
//                       <span className="type-icon">{term.typeIcon}</span>
//                       {term.typeLabel}
//                     </div>
//                   </td>
//                   <td>
//                     <div className="term-info">
//                       <h4 className="term-title">{term.title}</h4>
//                       <div className="term-meta">
//                         <span className="meta-item">
//                           <FiCalendar /> {term.effectiveDate}
//                         </span>
//                         <span className="meta-item">
//                           <FiUser /> {term.lastUpdatedBy}
//                         </span>
//                       </div>
//                     </div>
//                   </td>
//                   <td className="text-center">
//                     <span className="version-badge">v{term.version}</span>
//                   </td>
//                   <td className="text-center">
//                     {getStatusBadge(term.isActive)}
//                   </td>
//                   <td>
//                     <div className="update-info">
//                       <div className="update-date">{term.lastUpdated}</div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewTerms(term)}
//                         title="View Details"
//                       >
//                         <FiEye />
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditTerms(term)}
//                         title="Edit"
//                       >
//                         <FiEdit2 />
//                       </button>
//                       <button
//                         className="action-btn history"
//                         onClick={() => handleViewHistory(term.id, term.title)}
//                         title="View History"
//                       >
//                         <FiClock />
//                       </button>
//                       <button
//                         className={`action-btn ${term.isActive ? 'deactivate' : 'activate'}`}
//                         onClick={() => handleToggleStatus(term.id, term.isActive)}
//                         title={term.isActive ? 'Deactivate' : 'Activate'}
//                       >
//                         {term.isActive ? <FiToggleRight /> : <FiToggleLeft />}
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {filterTerms.length === 0 && !loading && (
//           <div className="empty-state">
//             <div className="empty-icon">📄</div>
//             <h3>No Terms Found</h3>
//             <p>No terms and conditions match your search criteria.</p>
//             <button className="btn btn-primary" onClick={handleCreateNew}>
//               <FiPlus /> Create Your First Terms
//             </button>
//           </div>
//         )}
//       </div>

//       {filterTerms.length > 0 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing <strong>{filterTerms.length}</strong> of <strong>{totalTerms}</strong> terms • Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn prev"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               <FiChevronLeft /> Previous
//             </button>
//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>
//             <button
//               className="pagination-btn next"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next <FiChevronRight />
//             </button>
//           </div>
//         </div>
//       )}

//       {error && (
//         <div className="notification error">
//           <FiAlertCircle /> {error}
//           <button className="close-notification" onClick={() => setError(null)}>
//             <FiX />
//           </button>
//         </div>
//       )}

//       {success && (
//         <div className="notification success">
//           <FiCheck /> {success}
//           <button className="close-notification" onClick={() => setSuccess(null)}>
//             <FiX />
//           </button>
//         </div>
//       )}

//       {/* ============================================================
//           VIEW MODAL - WITH SANITIZED CONTENT
//           ============================================================ */}

//       {viewingTerms && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content view-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <div className="modal-title-section">
//                 <h2>{viewingTerms.title}</h2>
//                 <div className="modal-subtitle">
//                   <span className="type-badge" style={{ backgroundColor: viewingTerms.typeColor + '15', color: viewingTerms.typeColor }}>
//                     {viewingTerms.typeIcon} {viewingTerms.typeLabel}
//                   </span>
//                   <span className="version-badge">Version {viewingTerms.version}</span>
//                 </div>
//               </div>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="terms-metadata">
//                 <div className="metadata-grid">
//                   <div className="metadata-item">
//                     <label><FiCalendar /> Effective Date</label>
//                     <span>{viewingTerms.effectiveDate}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiClock /> Last Updated</label>
//                     <span>{viewingTerms.lastUpdated}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiUser /> Updated By</label>
//                     <span>{viewingTerms.lastUpdatedBy}</span>
//                   </div>
//                   <div className="metadata-item">
//                     <label><FiInfo /> Status</label>
//                     {getStatusBadge(viewingTerms.isActive)}
//                   </div>
//                 </div>
//               </div>
              
//               <div className="terms-content-preview">
//                 <div className="content-header">
//                   <h3>Content</h3>
//                   <span className="section-count">{viewingTerms.sections?.length || 1} Sections</span>
//                 </div>
//                 <div className="sections-container">
//                   {viewingTerms.sections?.map((section, index) => (
//                     <div key={index} className="section-item">
//                       <div className="section-header">
//                         <h4 className="section-title">
//                           <span className="section-number">{index + 1}.</span>
//                           {section.title}
//                         </h4>
//                       </div>
//                       {/* ✅ FIXED: Sanitize content before rendering */}
//                       <div 
//                         className="section-content"
//                         dangerouslySetInnerHTML={{ __html: sanitizeHTML(section.content) }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {viewingTerms && isFetchingDetails && <SkeletonModal />}

//       {/* ============================================================
//           HISTORY MODAL
//           ============================================================ */}

//       {showHistoryModal && selectedHistory && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeHistoryModal}>
//           <div className="modal-content history-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <div className="modal-title-section">
//                 <h2>Version History</h2>
//                 <p className="modal-subtitle">{selectedHistory.termTitle}</p>
//               </div>
//               <button className="modal-close-btn" onClick={closeHistoryModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               {selectedHistory.history.length > 0 ? (
//                 <div className="history-timeline">
//                   {selectedHistory.history
//                     .sort((a, b) => b.version - a.version)
//                     .map((version, index) => (
//                       <div key={index} className="timeline-item">
//                         <div className="timeline-marker">
//                           <div className="marker-dot"></div>
//                           {index < selectedHistory.history.length - 1 && (
//                             <div className="timeline-line"></div>
//                           )}
//                         </div>
//                         <div className="timeline-content">
//                           <div className="version-header">
//                             <div className="version-left">
//                               <span className="version-number">Version {version.version}</span>
//                               <span className="version-date">
//                                 {new Date(version.updatedAt || version.createdAt).toLocaleDateString('en-US', {
//                                   year: 'numeric',
//                                   month: 'short',
//                                   day: 'numeric',
//                                   hour: '2-digit',
//                                   minute: '2-digit'
//                                 })}
//                               </span>
//                             </div>
//                             <div className="version-right">
//                               <span className={`status-badge ${version.isActive ? 'active' : 'inactive'}`}>
//                                 {version.isActive ? 'Active' : 'Inactive'}
//                               </span>
//                             </div>
//                           </div>
//                           {version.changeReason && (
//                             <div className="change-reason">
//                               <strong>Change Reason:</strong> {version.changeReason}
//                             </div>
//                           )}
//                           {version.updatedBy && (
//                             <div className="updated-by">
//                               <FiUser /> Updated by: {version.updatedBy.name || 'System'}
//                             </div>
//                           )}
//                           <div className="version-preview">
//                             <div className="preview-title">{version.title}</div>
//                             <div className="preview-content">
//                               {version.sections && version.sections.length > 0 ? (
//                                 version.sections.slice(0, 2).map((section, idx) => (
//                                   <div key={idx} className="preview-section">
//                                     <strong>{section.title}</strong>
//                                     {/* ✅ FIXED: Sanitize history content */}
//                                     <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(section.content.replace(/<[^>]*>/g, '').substring(0, 150)) }} />
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(version.content.replace(/<[^>]*>/g, '').substring(0, 200)) }} />
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               ) : (
//                 <div className="empty-history">
//                   <FiClock className="history-icon" />
//                   <h3>No History Available</h3>
//                   <p>No version history found for this term.</p>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeHistoryModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ============================================================
//           CREATE MODAL - WITH SANITIZATION ON SUBMIT
//           ============================================================ */}

//       {showCreateModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeCreateModal}>
//           <div className="modal-content create-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Create New Terms</h2>
//               <button className="modal-close-btn" onClick={closeCreateModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="create-form">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Type *</label>
//                     <div className="type-select-grid">
//                       {termTypes.filter(t => t.value).map(type => (
//                         <div 
//                           key={type.value}
//                           className={`type-option ${newTermsForm.type === type.value ? 'selected' : ''}`}
//                           onClick={() => setNewTermsForm({...newTermsForm, type: type.value})}
//                           style={{ borderColor: type.color }}
//                         >
//                           <span className="type-icon-large">{type.icon}</span>
//                           <span className="type-label">{type.label}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Title *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       placeholder="Enter terms title..."
//                       value={newTermsForm.title}
//                       onChange={(e) => setNewTermsForm({...newTermsForm, title: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Effective Date</label>
//                     <input
//                       type="date"
//                       className="form-input"
//                       value={newTermsForm.effectiveDate}
//                       onChange={(e) => setNewTermsForm({...newTermsForm, effectiveDate: e.target.value})}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="sections-editor">
//                   <div className="editor-header">
//                     <h3>Sections</h3>
//                     <button type="button" className="btn btn-sm btn-outline" onClick={handleAddSection}>
//                       <FiPlus /> Add Section
//                     </button>
//                   </div>
                  
//                   <div className="sections-list">
//                     {newTermsForm.sections.map((section, index) => (
//                       <div key={index} className="section-editor-item">
//                         <div className="section-editor-header">
//                           <h4>Section {index + 1}</h4>
//                           {newTermsForm.sections.length > 1 && (
//                             <button 
//                               type="button" 
//                               className="btn btn-sm btn-danger"
//                               onClick={() => handleRemoveSection(index)}
//                             >
//                               <FiTrash2 /> Remove
//                             </button>
//                           )}
//                         </div>
//                         <div className="form-group">
//                           <label>Header/Title *</label>
//                           <input
//                             type="text"
//                             className="form-input"
//                             placeholder="Enter section title..."
//                             value={section.title}
//                             onChange={(e) => handleSectionChange(index, 'title', e.target.value)}
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Content/Paragraph *</label>
//                           <textarea
//                             className="form-textarea"
//                             rows="6"
//                             placeholder="Enter section content..."
//                             value={section.content}
//                             onChange={(e) => handleSectionChange(index, 'content', e.target.value)}
//                           />
//                           <div className="textarea-footer">
//                             <span className="char-count">{section.content.length} characters</span>
//                             <span className="html-tip">
//                               <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeCreateModal}>
//                 Cancel
//               </button>
//               <button className="btn btn-primary" onClick={handleCreateSubmit}>
//                 Create Terms
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showCreateModal && isFetchingDetails && <SkeletonFormModal />}

//       {/* ============================================================
//           EDIT MODAL - WITH SANITIZATION ON SUBMIT
//           ============================================================ */}

//       {showEditModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeEditModal}>
//           <div className="modal-content edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Edit Terms and Conditions</h2>
//               <button className="modal-close-btn" onClick={closeEditModal}>
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Title *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       value={editForm.title}
//                       onChange={(e) => setEditForm({...editForm, title: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Effective Date</label>
//                     <input
//                       type="date"
//                       className="form-input"
//                       value={editForm.effectiveDate}
//                       onChange={(e) => setEditForm({...editForm, effectiveDate: e.target.value})}
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <div className="status-toggle">
//                       <label className={`toggle-label ${editForm.isActive ? 'active' : ''}`}>
//                         <input
//                           type="checkbox"
//                           checked={editForm.isActive}
//                           onChange={(e) => setEditForm({...editForm, isActive: e.target.checked})}
//                         />
//                         <span className="toggle-slider"></span>
//                         <span className="toggle-text">{editForm.isActive ? 'Active' : 'Inactive'}</span>
//                       </label>
//                     </div>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Change Reason *</label>
//                     <input
//                       type="text"
//                       className="form-input"
//                       placeholder="Explain why you're making these changes..."
//                       value={editForm.changeReason}
//                       onChange={(e) => setEditForm({...editForm, changeReason: e.target.value})}
//                     />
//                   </div>
//                 </div>
                
//                 <div className="sections-editor">
//                   <div className="editor-header">
//                     <h3>Sections ({editForm.sections?.length || 0})</h3>
//                     <button type="button" className="btn btn-sm btn-outline" onClick={handleAddEditSection}>
//                       <FiPlus /> Add Section
//                     </button>
//                   </div>
                  
//                   <div className="sections-list">
//                     {editForm.sections?.map((section, index) => (
//                       <div key={index} className="section-editor-item">
//                         <div className="section-editor-header">
//                           <h4>Section {index + 1}</h4>
//                           {editForm.sections.length > 1 && (
//                             <button 
//                               type="button" 
//                               className="btn btn-sm btn-danger"
//                               onClick={() => handleRemoveEditSection(index)}
//                             >
//                               <FiTrash2 /> Remove
//                             </button>
//                           )}
//                         </div>
//                         <div className="form-group">
//                           <label>Header/Title *</label>
//                           <input
//                             type="text"
//                             className="form-input"
//                             value={section.title}
//                             onChange={(e) => handleEditSectionChange(index, 'title', e.target.value)}
//                           />
//                         </div>
//                         <div className="form-group">
//                           <label>Content/Paragraph *</label>
//                           <textarea
//                             className="form-textarea"
//                             rows="6"
//                             value={section.content}
//                             onChange={(e) => handleEditSectionChange(index, 'content', e.target.value)}
//                           />
//                           <div className="textarea-footer">
//                             <span className="char-count">{section.content.length} characters</span>
//                             <span className="html-tip">
//                               <FiInfo /> Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-secondary" onClick={closeEditModal}>
//                 Cancel
//               </button>
//               <button className="btn btn-primary" onClick={handleSaveEdit}>
//                 Update Terms
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showEditModal && isFetchingDetails && <SkeletonFormModal />}
//     </div>
//   );
// };

// export default TermsAndConditions;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DOMPurify from 'dompurify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/TermsManage.css';
import {
  getAllTerms,
  getTermsById,
  createTerms,
  updateTerms,
  toggleTermsStatus,
  getTermsHistory
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ============================================================
// SANITIZATION CONFIG
// ============================================================
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'b', 'i', 'u', 'em', 'strong', 'p', 'br',
    'ul', 'ol', 'li', 'dl', 'dt', 'dd',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'table', 'thead', 'tbody', 'tr', 'td', 'th',
    'blockquote', 'pre', 'code', 'hr', 'div', 'span',
    'a', 'abbr', 'address', 'cite', 'q'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id', 'style', 'title', 'align', 'colspan', 'rowspan'],
  ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
};

const sanitizeHTML = (content) => {
  if (!content || typeof content !== 'string') return '';
  return DOMPurify.sanitize(content, SANITIZE_CONFIG);
};

const sanitizeSections = (sections) => {
  if (!sections || !Array.isArray(sections)) return sections;
  return sections.map(section => ({
    ...section,
    content: DOMPurify.sanitize(section.content, SANITIZE_CONFIG)
  }));
};

// ---------- term type metadata ----------
const TERM_TYPES = {
  general:    { label: 'General Terms',    icon: 'file',    tone: 'active'   },
  passenger:  { label: 'Passenger Terms',  icon: 'user',    tone: 'pending'  },
  bus_owner:  { label: 'Bus Owner Terms',  icon: 'bus',     tone: 'amber'    },
  privacy:    { label: 'Privacy Policy',   icon: 'info',    tone: 'indigo'   },
  cookie:     { label: 'Cookie Policy',    icon: 'tag',     tone: 'info'     },
  refund:     { label: 'Refund Policy',    icon: 'wallet',  tone: 'inactive' },
};
const getTypeMeta = (t) => TERM_TYPES[t] || { label: t || 'N/A', icon: 'file', tone: 'inactive' };

const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const safeArr = (v) => (Array.isArray(v) ? v : []);

const TypePill = ({ value }) => {
  const meta = getTypeMeta(value);
  return <span className={`prm-status tone-${meta.tone}`}><Icon name={meta.icon} size={12} /> {meta.label}</span>;
};
const StatusPill = ({ value }) => (
  <span className={`prm-status ${value ? 'active' : 'inactive'}`}>{value ? 'Active' : 'Inactive'}</span>
);

// ============================================================
// Term card
// ============================================================
const TermCard = ({ term, index, onView, onEdit, onHistory, onToggle }) => (
  <div className="prm-card cr-card" style={{ animationDelay: `${index * 60}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 44, height: 44 }}>
          <Icon name={getTypeMeta(term.type).icon} size={20} />
        </span>
        <div>
          <div className="prm-card-no">#{String(term.serialNo).padStart(2, '0')} · v{term.version}</div>
          <h3 className="prm-card-title">{safeStr(term.title) || 'N/A'}</h3>
          <div className="prm-card-sub">
            <Icon name="calendar" size={14} /> Effective {safeStr(term.effectiveDate)}
          </div>
        </div>
      </div>
      <StatusPill value={term.isActive} />
    </div>

    <div className="pbo-contact">
      <div><TypePill value={term.type} /></div>
      <div><Icon name="user" size={14} /> {safeStr(term.lastUpdatedBy) || 'System Admin'}</div>
      <div><Icon name="clock" size={14} /> Updated {safeStr(term.lastUpdated)}</div>
    </div>

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(term)}>
        <Icon name="eye" size={14} /> View
      </button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(term)}>
        <Icon name="edit" size={14} /> Edit
      </button>
      <button className="prm-btn ghost sm" onClick={() => onHistory(term.id, term.title)}>
        <Icon name="clock" size={14} /> History
      </button>
      <button className="prm-btn ghost sm" onClick={() => onToggle(term.id, term.isActive)} title={term.isActive ? 'Deactivate' : 'Activate'}>
        <Icon name={term.isActive ? 'x' : 'check'} size={14} />
      </button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const TermsAndConditions = () => {
  const { token } = useSelector(state => state.user);

  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('');
  const [layout, setLayout] = useState('table');
  const [showFilters, setShowFilters] = useState(false);

  const [editingTerms, setEditingTerms] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingTerms, setViewingTerms] = useState(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [savingCreate, setSavingCreate] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);

  const [newTermsForm, setNewTermsForm] = useState({
    type: '', title: '',
    sections: [{ title: '', content: '' }],
    effectiveDate: new Date().toISOString().split('T')[0]
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalTerms, setTotalTerms] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalTerms / pageSize));

  // ---------- fetch ----------
  useEffect(() => {
    const t = setTimeout(fetchTerms, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm, filterType]);

  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const fetchTerms = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllTerms(token, currentPage, pageSize, filterType, searchTerm);
      if (response && response.success) {
        const transformed = response.terms.map((term, index) => {
          const meta = getTypeMeta(term.type);
          return {
            id: term._id || term.id,
            serialNo: (currentPage - 1) * pageSize + index + 1,
            type: term.type,
            typeLabel: meta.label,
            typeIcon: meta.icon,
            typeTone: meta.tone,
            title: term.title,
            version: term.version,
            isActive: term.isActive,
            effectiveDate: new Date(term.effectiveDate).toLocaleDateString('en-US'),
            effectiveDateRaw: term.effectiveDate,
            lastUpdated: new Date(term.updatedAt || term.lastUpdatedAt).toLocaleDateString('en-US'),
            lastUpdatedBy: term.lastUpdatedBy?.name || 'System Admin',
            content: term.content
          };
        });
        setTerms(transformed);
        setTotalTerms(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch terms and conditions.');
      console.error(err);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  // ---------- content parsing ----------
  const parseContentToSections = (content) => {
    const sections = [];
    if (!content) return sections;
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const sectionElements = doc.querySelectorAll('.terms-section');
    if (sectionElements.length > 0) {
      sectionElements.forEach((sectionEl) => {
        const titleEl = sectionEl.querySelector('.section-title');
        const contentEl = sectionEl.querySelector('.section-content');
        if (titleEl && contentEl) {
          sections.push({
            title: titleEl.textContent.replace(/^\d+\.\s*/, ''),
            content: contentEl.innerHTML
          });
        }
      });
    }
    return sections;
  };

  // ---------- view / history / edit ----------
  const handleViewTerms = async (term) => {
    try {
      setIsFetchingDetails(true);
      setViewingTerms(term);
      const response = await getTermsById(term.id, token);
      if (response.success) {
        const sections = parseContentToSections(response.terms.content);
        setViewingTerms({
          ...term,
          sections: sections.length > 0 ? sections : [{ title: 'Full Terms', content: response.terms.content }]
        });
      }
    } catch (err) {
      setError('Failed to fetch term details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleViewHistory = async (termId, termTitle) => {
    try {
      setIsFetchingDetails(true);
      const response = await getTermsHistory(termId, token);
      if (response.success) {
        setSelectedHistory({ termId, termTitle, history: response.history || [] });
        setShowHistoryModal(true);
      }
    } catch (err) {
      setError('Failed to fetch history.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditTerms = async (term) => {
    try {
      setIsFetchingDetails(true);
      const response = await getTermsById(term.id, token);
      if (response.success) {
        const sections = parseContentToSections(response.terms.content);
        setEditingTerms(term.id);
        setEditForm({
          title: term.title,
          sections: sections.length > 0 ? sections : [{ title: 'Terms and Conditions', content: response.terms.content }],
          isActive: term.isActive,
          effectiveDate: new Date(term.effectiveDateRaw).toISOString().split('T')[0],
          changeReason: ''
        });
        setShowEditModal(true);
      }
    } catch (err) {
      setError('Failed to load term for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  // ---------- create ----------
  const handleCreateNew = () => {
    setShowCreateModal(true);
    setNewTermsForm({
      type: '', title: '',
      sections: [
        { title: 'Acceptance of Terms', content: 'By accessing and using this website, you agree to be bound by these terms and conditions.' },
        { title: 'User Responsibilities', content: 'Users must provide accurate information and use the service responsibly.' }
      ],
      effectiveDate: new Date().toISOString().split('T')[0]
    });
  };

  const handleAddSection = () => {
    setNewTermsForm(f => ({ ...f, sections: [...f.sections, { title: '', content: '' }] }));
  };
  const handleRemoveSection = (index) => {
    if (newTermsForm.sections.length <= 1) return;
    const ns = [...newTermsForm.sections]; ns.splice(index, 1);
    setNewTermsForm(f => ({ ...f, sections: ns }));
  };
  const handleSectionChange = (index, field, value) => {
    const ns = [...newTermsForm.sections]; ns[index][field] = value;
    setNewTermsForm(f => ({ ...f, sections: ns }));
  };

  const handleCreateSubmit = async () => {
    try {
      setError(null);
      if (!newTermsForm.type || !newTermsForm.title || !newTermsForm.sections.length) {
        return toast.error('Please fill all required fields');
      }
      for (let i = 0; i < newTermsForm.sections.length; i++) {
        if (!newTermsForm.sections[i].title.trim() || !newTermsForm.sections[i].content.trim()) {
          return toast.error(`Please fill both header and content for section ${i + 1}`);
        }
      }
      setSavingCreate(true);
      const sanitizedSections = sanitizeSections(newTermsForm.sections);
      const response = await createTerms({ ...newTermsForm, sections: sanitizedSections }, token);
      if (response.success) {
        toast.success('Terms and conditions created successfully');
        setShowCreateModal(false);
        fetchTerms();
      } else {
        toast.error(response.message || 'Failed to create terms');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create terms');
    } finally {
      setSavingCreate(false);
    }
  };

  // ---------- edit ----------
  const handleEditSectionChange = (index, field, value) => {
    const ns = [...editForm.sections]; ns[index][field] = value;
    setEditForm(f => ({ ...f, sections: ns }));
  };
  const handleAddEditSection = () => setEditForm(f => ({ ...f, sections: [...f.sections, { title: '', content: '' }] }));
  const handleRemoveEditSection = (index) => {
    if (editForm.sections.length <= 1) return;
    const ns = [...editForm.sections]; ns.splice(index, 1);
    setEditForm(f => ({ ...f, sections: ns }));
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      if (!editForm.changeReason) return toast.error('Please provide a change reason for this update');
      for (let i = 0; i < editForm.sections.length; i++) {
        if (!editForm.sections[i].title.trim() || !editForm.sections[i].content.trim()) {
          return toast.error(`Please fill both header and content for section ${i + 1}`);
        }
      }
      setSavingEdit(true);
      const sanitizedSections = sanitizeSections(editForm.sections);
      const response = await updateTerms(editingTerms, { ...editForm, sections: sanitizedSections }, token);
      if (response.success) {
        toast.success('Terms updated successfully');
        setEditingTerms(null);
        setEditForm({});
        setShowEditModal(false);
        fetchTerms();
      } else {
        toast.error(response.message || 'Failed to update terms');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update terms');
    } finally {
      setSavingEdit(false);
    }
  };

  // ---------- toggle / refresh / export ----------
  const handleToggleStatus = async (termId, currentStatus) => {
    try {
      setError(null);
      const response = await toggleTermsStatus(termId, token);
      if (response.success) {
        toast.success(`Terms ${currentStatus ? 'deactivated' : 'activated'} successfully`);
        fetchTerms();
      }
    } catch (err) {
      toast.error('Failed to update status');
    }
  };

  const handleRefresh = () => {
    setSearchTerm(''); setFilterType(''); setCurrentPage(1);
    fetchTerms();
  };

  const handleExportCSV = () => {
    if (terms.length === 0) return toast.warning('No data to export');
    const headers = ['ID', 'Type', 'Title', 'Version', 'Status', 'Effective Date', 'Last Updated', 'Updated By'];
    const rows = terms.map(t => [
      t.id, t.typeLabel, t.title, t.version,
      t.isActive ? 'Active' : 'Inactive',
      t.effectiveDate, t.lastUpdated, t.lastUpdatedBy
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `terms-and-conditions-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  // ---------- close handlers ----------
  const closeViewModal = () => setViewingTerms(null);
  const closeHistoryModal = () => { setShowHistoryModal(false); setSelectedHistory(null); };
  const closeCreateModal = () => {
    setShowCreateModal(false);
    setNewTermsForm({ type: '', title: '', sections: [{ title: '', content: '' }], effectiveDate: new Date().toISOString().split('T')[0] });
  };
  const closeEditModal = () => { setShowEditModal(false); setEditingTerms(null); setEditForm({}); };

  const activeOnPage = terms.filter(t => t.isActive).length;
  const typesOnPage = useMemo(() => [...new Set(terms.map(t => t.type))].length, [terms]);
  const latestVersion = terms.length > 0 ? Math.max(...terms.map(t => t.version || 1)) : 0;

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="file" size={13} /> Policies</span>
          <h1>Terms & Conditions</h1><p>Loading…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="file" size={13} /> Policies & Agreements</span>
          <h1>Terms & Conditions</h1>
          <p>Manage all terms, policies, and agreements — with version history and audit trail.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search terms by title or type…"
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
            )}
          </div>
          <button className="pbo-icon-btn" onClick={() => setShowFilters(!showFilters)} title="Filters">
            <Icon name="list" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleExportCSV} title="Export CSV">
            <Icon name="download" size={17} />
          </button>
          <button className="prm-add-btn" onClick={handleCreateNew}>
            <span className="plus"><Icon name="plus" size={14} /></span> Create New
          </button>
        </div>
      </div>

      {error && (
        <div className="cr-error">
          <Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={fetchTerms}>Retry</button>
        </div>
      )}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="file" tone="indigo" label="Total Terms" value={totalTerms} hint="All policies" delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
        <StatCard icon="tag" tone="cyan" label="Types" value={typesOnPage} hint="Distinct types on this page" delay={240} />
        <StatCard icon="clock" tone="amber" label="Latest Version" value={latestVersion} hint="Highest version on this page" delay={320} />
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button
              className={`prm-chip ${filterType === '' ? 'active' : ''}`}
              onClick={() => { setFilterType(''); setCurrentPage(1); }}
            >
              All <span className="count">{terms.length}</span>
            </button>
            {Object.entries(TERM_TYPES).map(([k, v]) => (
              <button
                key={k}
                className={`prm-chip ${filterType === k ? 'active' : ''}`}
                onClick={() => { setFilterType(k); setCurrentPage(1); }}
              >
                <Icon name={v.icon} size={12} /> {v.label}
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
          {loading && terms.length > 0 && <span className="prm-tag gray">loading…</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{terms.length}</b> of {totalTerms}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view">
              <Icon name="grid" size={17} />
            </button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view">
              <Icon name="list" size={17} />
            </button>
          </div>
        </div>
      </div>

      {/* FILTER PANEL */}
      {showFilters && (
        <div className="prm-form-modal prm-form-modal-sm" style={{ marginBottom: 16 }}>
          <div className="prm-form-head">
            <div className="prm-form-head-row">
              <span className="prm-form-badge"><Icon name="search" size={22} /></span>
              <div><h3>Filter terms</h3><p>Refine the current result set</p></div>
            </div>
            <button className="prm-modal-close" onClick={() => setShowFilters(false)}>×</button>
          </div>
          <div className="prm-form-body">
            <div className="prm-fgrid">
              <Field label="Type">
                <select className="prm-input prm-select" value={filterType} onChange={(e) => { setFilterType(e.target.value); setCurrentPage(1); }}>
                  <option value="">All Types</option>
                  {Object.entries(TERM_TYPES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
              </Field>
            </div>
          </div>
          <div className="prm-form-foot">
            <span className="prm-foot-hint">{filterType ? `Filtering by ${getTypeMeta(filterType).label}` : 'No active filters'}</span>
            <div className="prm-form-foot-actions">
              <button className="prm-btn ghost" onClick={() => { setFilterType(''); setSearchTerm(''); setCurrentPage(1); }}>Clear all</button>
              <button className="prm-btn primary" onClick={() => setShowFilters(false)}>Apply</button>
            </div>
          </div>
        </div>
      )}

      {/* LIST */}
      <div className={loading && terms.length > 0 ? 'cr-loading' : ''}>
        {terms.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || filterType ? 'search' : 'file'} size={44} /></div>
            <h3>{searchTerm || filterType ? 'No terms match your filters' : 'No terms yet'}</h3>
            <p>{searchTerm || filterType ? 'Try a different search or clear the filters.' : 'Click “Create New” to add your first terms.'}</p>
            {(searchTerm || filterType)
              ? <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>
              : <button className="prm-btn primary" onClick={handleCreateNew}><Icon name="plus" size={15} /> Create New</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {terms.map((term, i) => (
              <TermCard
                key={term.id}
                term={term}
                index={i}
                onView={handleViewTerms}
                onEdit={handleEditTerms}
                onHistory={handleViewHistory}
                onToggle={handleToggleStatus}
              />
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>#</th><th>Type</th><th>Title</th><th>Version</th><th>Status</th><th>Last Updated</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {terms.map((term, i) => (
                  <tr key={term.id} style={{ animationDelay: `${i * 50}ms` }}>
                    <td>{term.serialNo}</td>
                    <td><TypePill value={term.type} /></td>
                    <td>
                      <div className="name">{safeStr(term.title)}</div>
                      <div className="sub">
                        <Icon name="calendar" size={12} /> {term.effectiveDate} · <Icon name="user" size={12} /> {term.lastUpdatedBy}
                      </div>
                    </td>
                    <td><span className="prm-tag gray">v{term.version}</span></td>
                    <td><StatusPill value={term.isActive} /></td>
                    <td>{term.lastUpdated}</td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewTerms(term)} title="View"><Icon name="eye" size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleEditTerms(term)} title="Edit"><Icon name="edit" size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleViewHistory(term.id, term.title)} title="History"><Icon name="clock" size={13} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleToggleStatus(term.id, term.isActive)} title={term.isActive ? 'Deactivate' : 'Activate'}><Icon name={term.isActive ? 'x' : 'check'} size={13} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalTerms}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="terms"
      />

      {/* VIEW MODAL */}
      {viewingTerms && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal" style={{ maxWidth: 800 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name={getTypeMeta(viewingTerms.type).icon} size={22} /></span>
                <div>
                  <h3>{safeStr(viewingTerms.title)}</h3>
                  <p><TypePill value={viewingTerms.type} /> · v{safeStr(viewingTerms.version)}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="pbo-mini-stats">
                <div><span>Effective</span><b>{safeStr(viewingTerms.effectiveDate)}</b></div>
                <div><span>Last Updated</span><b>{safeStr(viewingTerms.lastUpdated)}</b></div>
                <div><span>Updated By</span><b>{safeStr(viewingTerms.lastUpdatedBy)}</b></div>
                <div><span>Status</span><b><StatusPill value={viewingTerms.isActive} /></b></div>
              </div>

              <div className="prm-section-title">
                Content <span style={{ fontWeight: 400, color: '#718096', fontSize: 13 }}>
                  ({viewingTerms.sections?.length || 1} sections)
                </span>
              </div>

              {safeArr(viewingTerms.sections).map((section, index) => (
                <div key={index} className="prm-card cr-card" style={{ marginBottom: 12 }}>
                  <div className="prm-card-top">
                    <h4 style={{ margin: 0 }}>{index + 1}. {safeStr(section.title)}</h4>
                  </div>
                  <div
                    style={{ color: '#2d3748', lineHeight: 1.6 }}
                    dangerouslySetInnerHTML={{ __html: sanitizeHTML(section.content) }}
                  />
                </div>
              ))}

              {isFetchingDetails && <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>Refreshing…</div>}
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { const t = viewingTerms; closeViewModal(); handleEditTerms(t); }}>
                  <Icon name="edit" size={15} /> Edit
                </button>
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* HISTORY MODAL */}
      {showHistoryModal && selectedHistory && (
        <div className="prm-overlay" onClick={closeHistoryModal}>
          <div className="prm-form-modal" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="clock" size={22} /></span>
                <div>
                  <h3>Version history</h3>
                  <p>{selectedHistory.termTitle}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeHistoryModal}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {selectedHistory.history.length > 0 ? (
                selectedHistory.history
                  .slice()
                  .sort((a, b) => b.version - a.version)
                  .map((version, index) => (
                    <div key={index} className="prm-card cr-card" style={{ marginBottom: 12 }}>
                      <div className="prm-card-top">
                        <div className="pbo-owner-id">
                          <span className="prm-form-badge" style={{ width: 40, height: 40 }}>
                            v{version.version}
                          </span>
                          <div>
                            <div className="prm-card-no">
                              {new Date(version.updatedAt || version.createdAt).toLocaleString('en-US', {
                                year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
                              })}
                            </div>
                            <div className="prm-card-sub">
                              <StatusPill value={version.isActive} />
                            </div>
                          </div>
                        </div>
                      </div>
                      {version.changeReason && (
                        <div style={{ marginTop: 8, fontSize: 13, color: '#4a5568' }}>
                          <b>Change reason:</b> {version.changeReason}
                        </div>
                      )}
                      {version.updatedBy && (
                        <div style={{ marginTop: 6, fontSize: 12, color: '#718096' }}>
                          <Icon name="user" size={12} /> Updated by: {version.updatedBy.name || 'System'}
                        </div>
                      )}
                      <div style={{ marginTop: 8, fontSize: 13, color: '#2d3748' }}>
                        <b>{safeStr(version.title)}</b>
                        {safeArr(version.sections).slice(0, 2).map((section, idx) => (
                          <div key={idx} style={{ marginTop: 6 }}>
                            <b>{safeStr(section.title)}</b>
                            <div
                              style={{ color: '#718096' }}
                              dangerouslySetInnerHTML={{ __html: sanitizeHTML(safeStr(section.content).replace(/<[^>]*>/g, '').substring(0, 150)) }}
                            />
                          </div>
                        ))}
                        {!safeArr(version.sections).length && version.content && (
                          <div
                            style={{ marginTop: 6, color: '#718096' }}
                            dangerouslySetInnerHTML={{ __html: sanitizeHTML(safeStr(version.content).replace(/<[^>]*>/g, '').substring(0, 200)) }}
                          />
                        )}
                      </div>
                    </div>
                  ))
              ) : (
                <div className="prm-empty" style={{ margin: 0 }}>
                  <div className="icon"><Icon name="clock" size={44} /></div>
                  <h3>No history available</h3>
                  <p>No version history found for this term.</p>
                </div>
              )}
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeHistoryModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CREATE MODAL */}
      {showCreateModal && (
        <div className="prm-overlay" onClick={closeCreateModal}>
          <div className="prm-form-modal" style={{ maxWidth: 780 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={22} /></span>
                <div><h3>Create new terms</h3><p>Publish a new policy or agreement</p></div>
              </div>
              <button className="prm-modal-close" onClick={closeCreateModal}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="prm-section-title">Type <em>*</em></div>
              <div className="prm-chips" style={{ flexWrap: 'wrap' }}>
                {Object.entries(TERM_TYPES).map(([k, v]) => (
                  <button
                    key={k}
                    type="button"
                    className={`prm-chip ${newTermsForm.type === k ? 'active' : ''}`}
                    onClick={() => setNewTermsForm(f => ({ ...f, type: k }))}
                  >
                    <Icon name={v.icon} size={12} /> {v.label}
                  </button>
                ))}
              </div>

              <div className="prm-fgrid" style={{ marginTop: 12 }}>
                <Field label="Title" required full>
                  <input className="prm-input" value={newTermsForm.title}
                    onChange={(e) => setNewTermsForm(f => ({ ...f, title: e.target.value }))}
                    placeholder="Enter terms title…" />
                </Field>
                <Field label="Effective Date" full>
                  <input type="date" className="prm-input" value={newTermsForm.effectiveDate}
                    onChange={(e) => setNewTermsForm(f => ({ ...f, effectiveDate: e.target.value }))} />
                </Field>
              </div>

              <div className="prm-section-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                Sections
                <button type="button" className="prm-btn ghost sm" onClick={handleAddSection}>
                  <Icon name="plus" size={13} /> Add Section
                </button>
              </div>

              {newTermsForm.sections.map((section, index) => (
                <div key={index} className="prm-card cr-card" style={{ marginBottom: 12 }}>
                  <div className="prm-card-top">
                    <h4 style={{ margin: 0 }}>Section {index + 1}</h4>
                    {newTermsForm.sections.length > 1 && (
                      <button type="button" className="prm-btn ghost sm" onClick={() => handleRemoveSection(index)}>
                        <Icon name="trash" size={13} /> Remove
                      </button>
                    )}
                  </div>
                  <Field label="Header / Title" required>
                    <input className="prm-input" value={section.title}
                      onChange={(e) => handleSectionChange(index, 'title', e.target.value)}
                      placeholder="Enter section title…" />
                  </Field>
                  <Field label="Content / Paragraph" required note="Supports HTML: <b>, <i>, <u>, <a>, <ul>, <li>">
                    <textarea className="prm-input" rows="6" value={section.content}
                      onChange={(e) => handleSectionChange(index, 'content', e.target.value)}
                      placeholder="Enter section content…" />
                  </Field>
                  <div style={{ fontSize: 12, color: '#718096' }}>{section.content.length} characters</div>
                </div>
              ))}
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={closeCreateModal} disabled={savingCreate}>Cancel</button>
                <button className="prm-btn primary" onClick={handleCreateSubmit} disabled={savingCreate}>
                  <Icon name="check" size={15} /> {savingCreate ? 'Creating…' : 'Create Terms'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {showEditModal && (
        <div className="prm-overlay" onClick={closeEditModal}>
          <div className="prm-form-modal" style={{ maxWidth: 780 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>Edit terms</h3><p>Update content and publish a new version</p></div>
              </div>
              <button className="prm-modal-close" onClick={closeEditModal}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="prm-fgrid">
                <Field label="Title" required full>
                  <input className="prm-input" value={editForm.title || ''}
                    onChange={(e) => setEditForm(f => ({ ...f, title: e.target.value }))} />
                </Field>
                <Field label="Effective Date">
                  <input type="date" className="prm-input" value={editForm.effectiveDate || ''}
                    onChange={(e) => setEditForm(f => ({ ...f, effectiveDate: e.target.value }))} />
                </Field>
                <Field label="Status">
                  <button type="button" className={`prm-chip ${editForm.isActive ? 'active' : ''}`}
                    onClick={() => setEditForm(f => ({ ...f, isActive: !f.isActive }))}>
                    {editForm.isActive && <Icon name="check" size={12} />} {editForm.isActive ? 'Active' : 'Inactive'}
                  </button>
                </Field>
                <Field label="Change Reason" required full note="Explain why you're making these changes">
                  <input className="prm-input" value={editForm.changeReason || ''}
                    onChange={(e) => setEditForm(f => ({ ...f, changeReason: e.target.value }))}
                    placeholder="e.g., Updated refund policy for Q4" />
                </Field>
              </div>

              <div className="prm-section-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                Sections ({editForm.sections?.length || 0})
                <button type="button" className="prm-btn ghost sm" onClick={handleAddEditSection}>
                  <Icon name="plus" size={13} /> Add Section
                </button>
              </div>

              {safeArr(editForm.sections).map((section, index) => (
                <div key={index} className="prm-card cr-card" style={{ marginBottom: 12 }}>
                  <div className="prm-card-top">
                    <h4 style={{ margin: 0 }}>Section {index + 1}</h4>
                    {editForm.sections.length > 1 && (
                      <button type="button" className="prm-btn ghost sm" onClick={() => handleRemoveEditSection(index)}>
                        <Icon name="trash" size={13} /> Remove
                      </button>
                    )}
                  </div>
                  <Field label="Header / Title" required>
                    <input className="prm-input" value={section.title}
                      onChange={(e) => handleEditSectionChange(index, 'title', e.target.value)} />
                  </Field>
                  <Field label="Content / Paragraph" required note="Supports HTML: <b>, <i>, <u>, <a>, <ul>, <li>">
                    <textarea className="prm-input" rows="6" value={section.content}
                      onChange={(e) => handleEditSectionChange(index, 'content', e.target.value)} />
                  </Field>
                  <div style={{ fontSize: 12, color: '#718096' }}>{section.content.length} characters</div>
                </div>
              ))}
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={closeEditModal} disabled={savingEdit}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit} disabled={savingEdit}>
                  <Icon name="check" size={15} /> {savingEdit ? 'Updating…' : 'Update Terms'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TermsAndConditions;